import { render, staticRenderFns } from "./IconCity.vue?vue&type=template&id=880173ea"
import script from "./IconCity.vue?vue&type=script&lang=js"
export * from "./IconCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports